//noinspection JSUnresolvedVariable
import React, { Component } from 'react'
import range from 'lodash/range'
import PropTypes from 'prop-types'
import { ButtonGroup, Button } from 'react-bootstrap'

class SmalldotPaginator extends Component {
    static propTypes = {
        initialPage: props => {
            if (typeof props.initialPage !== 'number') {
                return new Error('initialPage should be a number')
            }
            if (props.initialPage < 1) {
                return new Error('initialPage should be greater than or equal to 1')
            }
            if (props.initialPage > props.numberOfPages) {
                return new Error(
                    `initialPage should be less than or equal to ${props.numberOfPages}`
                )
            }
        },
        numberOfPages: PropTypes.number.isRequired,
        onPageChange: PropTypes.func,
        children: PropTypes.func.isRequired
    }

    static defaultProps = { initialPage: 1 }

    state = { currentPage: this.props.initialPage }

    setPage = page => {
        if (typeof page !== 'number') {
            throw new Error('page should be a number')
        }
        if (page < 1) {
            throw new Error('page should be greater than or equal to 1')
        }
        if (page > this.props.numberOfPages) {
            throw new Error(
                `page should be less than or equal to ${this.props.numberOfPages}`
            )
        }
        this.setState({ currentPage: page }, () => {
            if (this.props.onPageChange) {
                this.props.onPageChange(page)
            }
        })
    }

    incrementPage = () => {
        if (this.state.currentPage === this.props.numberOfPages) {
            return
        }
        this.setPage(this.state.currentPage + 1)
    }

    decrementPage = () => {
        if (this.state.currentPage === 1) {
            return
        }
        this.setPage(this.state.currentPage - 1)
    }

    render() {
        return this.props.children({
            currentPage: this.state.currentPage,
            numberOfPages: this.props.numberOfPages,
            setPage: this.setPage,
            incrementPage: this.incrementPage,
            decrementPage: this.decrementPage
        })
    }
}

const Paginator = ({ numberOfPages, onPageChange, initialPage }) => {
    return (
        <SmalldotPaginator initialPage={initialPage} numberOfPages={numberOfPages} onPageChange={onPageChange}>
            {({ currentPage, setPage, incrementPage, decrementPage }) => (
                <ButtonGroup className="ml-auto mr-auto">
                    <Button variant="outline-primary" disabled={currentPage === 1} onClick={e => { e.preventDefault(); decrementPage() }}>
                        &laquo;
                    </Button>
                    {range(currentPage - 3, currentPage + 3 + 1).map(page => {
                        if (page < 1 || page > numberOfPages) {
                            return null
                        }
                        return (
                            <Button key={page} variant={page === currentPage ? 'primary' : 'outline-primary'} onClick={e => { e.preventDefault(); setPage(page) }}>
                                {page}
                            </Button>
                        )
                    })}
                    <Button variant="outline-primary" disabled={currentPage === numberOfPages} onClick={e => { e.preventDefault(); incrementPage() }}>
                        &raquo;
                    </Button>
                </ButtonGroup>
            )}
        </SmalldotPaginator>
    )
}
Paginator.propTypes = {
    numberOfPages: PropTypes.number.isRequired,
    onPageChange: PropTypes.func.isRequired,
    initialPage: PropTypes.number.isRequired
}

export default Paginator